import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { AllNewsPage } from "@/components/news/all-news-page";
import { PageHeader } from "@/components/page-header";
import type { NewsRecord } from "@/lib/news-helpers";
import { pb } from "@/lib/pb";
import { useDocumentTitle } from "@/lib/use-document-title";

/** Ported from portal-ui/app/(pages)/news/page.tsx. */
function newsQuery(authId: string | undefined) {
  return {
    queryKey: ["news", "list-page", authId ?? "anon"] as const,
    queryFn: () =>
      pb.collection("news").getList<NewsRecord>(1, 50, {
        sort: "-created",
        skipTotal: true,
        fields: "id,title,text,type,date,created",
      }),
  };
}

export const Route = createFileRoute("/_app/news/")({
  loader: ({ context }) => context.queryClient.ensureQueryData(newsQuery(pb.authStore.model?.id)),
  component: NewsPage,
});

function NewsPage() {
  useDocumentTitle("News");
  const { data } = useSuspenseQuery(newsQuery(pb.authStore.model?.id));
  return (
    <>
      <PageHeader
        eyebrow="Updates"
        title="News"
        meta={`${data.items.length} announcement${data.items.length === 1 ? "" : "s"}`}
      />
      <AllNewsPage newsArray={data.items} />
    </>
  );
}
